import React, { Component, PropTypes } from 'react';
import DocumentTitle from 'react-document-title';
import { SubmissionError } from 'redux-form';
import zip from 'lodash/zip';
import { decamelizeKeys } from 'humps';
import { Redirect } from 'react-router-dom';
import { connect } from 'react-redux';
import Form from './Form';
import ProductTable from '../../components/ProductTable';
import { selectHydrated } from '../../redux/modules/cart/selectors';
import { checkoutCart } from '../../redux/actions';


class Checkout extends Component {
  static propTypes = {
    rows: PropTypes.array.isRequired,
    checkoutCart: PropTypes.func.isRequired
  }

  state = { success: false }

  onSubmit = values => {
    const payload = decamelizeKeys(values);
    this.props.checkoutCart(payload).then(
      reps => this.setState({success: true}),
      ({response, json}) => {
          const { nonFieldErrors: _error, ...errors } = json;
          throw new SubmissionError({...errors, _error});
      }
    )
  }

  render() {
    const { rows }  = this.props;
    if (this.state.success) {
      return <Redirect to="/profile/orders" />
    }
    return (
      <div className="container">
        <DocumentTitle title="Grozs - e-BML" />
        <h2 className="mt-5 mb-3">Grozs</h2>
        { rows.length === 0
          ? (<div>Jūsu grozs ir tukšs.</div>)
          : (<div>
              <ProductTable rows={rows} />
              <h2 className="mt-5 mb-3">Detaļas</h2>
              <Form onSubmit={this.onSubmit}/>
            </div>)
        }
      </div>
    )
  }
}


// @TODO reuse rows selctor
const mapStateToProps = (state, props) => {
  const cart = selectHydrated(state);
  return {
    rows: cart ? zip(cart.items, cart.result.items) : [],
    result: cart? cart.result : null,
  }
};

export default connect(mapStateToProps, {checkoutCart})(Checkout);



// WEBPACK FOOTER //
// ./src/scenes/Checkout/index.js